import { Component, Inject } from "@angular/core";
import { Team } from "@common/ADAPT.Common.Model/organisation/team";
import { ADAPT_DIALOG_DATA } from "@common/ux/adapt-common-dialog/adapt-common-dialog.globals";
import { BaseDialogComponent, DialogResolveData } from "@common/ux/adapt-common-dialog/base-dialog.component/base-dialog.component";

@Component({
    selector: "adapt-edit-team-roles-dialog",
    standalone: false,
    templateUrl: "./edit-team-roles-dialog.component.html",
})
export class EditTeamRolesDialogComponent extends BaseDialogComponent<Team, void> {
    public dialogName = "EditTeamRolesDialog";

    public constructor(@Inject(ADAPT_DIALOG_DATA) public team: Team) {
        super(DialogResolveData.NotRequired);
    }
}
